module.exports = __webpack_public_path__ + "img/grain.b4d92f07.png";